import { ReportsTypesComponents } from '@affiliate-cabinet/types'

const ROUTES_ROOT = {
  root: '/',
}

const ROUTES_AUTH = {
  activate: '/auth/activate/:token',
  resetPassword: '/auth/reset-password',
  resetPasswordRequest: '/auth/reset-password/request',
  signIn: '/auth/signin',
  signUp: '/auth/signup',
  twoFA: '/auth/2fa',
}

const ROUTES_ONBOARDING = {
  onboarding: '/onboarding',
}

const ROUTES_STATISTICS = {
  general: '/statistics/general',
  root: '/statistics',
  users: '/statistics/users',
}

const ROUTES_PROFILE = {
  profile: '/profile',
  profileKYC: '/profile/kyc',
  profileSecurity: '/profile/security',
  profileSettings: '/profile/settings',
  profileSettingsTab: '/profile/settings/:tabValue',
}

const ROUTES_INFO = {
  blog: 'https://blog.affstore.com/?utm_source=cabinet&utm_medium=new_section&utm_campaign=cabinet_promo',
}

const ROUTES_PAYMENTS = {
  paymentsTab: '/payments/:tabValue',
}

const ROUTES_POSTBACKS = {
  postbacksAll: '/postbacks/*',
  postbacksCreate: '/postbacks/create',
  postbacksEdit: '/postbacks/edit/',
  postbacksEditId: '/postbacks/edit/:id',
  postbacksInfo: '/postbacks/info',
  postbacksList: '/postbacks/list',
  postbacksRoot: '/postbacks',
  postbacksTelegram: '/postbacks/telegram',
  postbacksTelegramCreate: '/postbacks/telegram/create',
  postbacksTelegramEdit: '/postbacks/telegram/edit/:id',
}

const ROUTES_PROMO = {
  promoTab: '/promo/:tabValue',
  promoTabById: '/promo/:tabValue/:id',
}

const ROUTES_OFFERS = {
  offerModel: '/offers/:advertAlias/:model/',
  offers: '/offers',
  offersAdvertisers: '/offers/advertisers',
  offerTab: '/offers/:advertAlias/:model/:tabValue',
}

const ROUTES_SUB_AFFILIATE = {
  root: '/statistics',
  subAffiliate: '/statistics/referral',
}

const ROUTES_ERROR = {
  404: '/404',
  500: '/500',
}

const ROUTES_SHARED = {
  authenticatorRedirect: '/authenticator/redirect',
  byTransferToken: '/auth/by-transfer-token/:token',
  paymentAccountConfirm: '/payment-account/confirm/:token',
  privacyPolicy: '/privacy-policy',
  termsAndConditions: '/terms-and-conditions',
}

const ROUTES_SHARED_VALUES = Object.values(ROUTES_SHARED)

const ROUTES_DASHBOARD = {
  root: '/dashboard',
}

const ROUTES_TOP = {
  root: '/top10',
}

const ROUTES_CONTESTS_TABS: Record<
  '_paramsKey' | Exclude<ReportsTypesComponents['schemas']['ContestStatus'], 'calculating'>,
  Exclude<ReportsTypesComponents['schemas']['ContestStatus'], 'calculating'> | string
> = {
  _paramsKey: ':contestsState',
  active: 'active',
  completed: 'completed',
  upcoming: 'upcoming',
}
const ROUTES_CONTEST = {
  _paramsKey: ':id',
}
const ROUTES_CONTEST_TABS: Record<'_paramsKey' | 'info' | 'leaderboard', string> = {
  _paramsKey: ':contestTab',
  info: 'info',
  leaderboard: 'leaderboard',
}
const ROUTES_CONTESTS = {
  contestPath: `/contests/contest/${ROUTES_CONTEST._paramsKey}`,
  contestTabsPath: `/contests/contest/${ROUTES_CONTEST._paramsKey}/${ROUTES_CONTEST_TABS._paramsKey}`,
  root: '/contests',
  tabsPath: `/contests/${ROUTES_CONTESTS_TABS._paramsKey}`,
}

const ROUTES_LOYALTY_PROGRAM = {
  achievements: '/loyalty-program/achievements',
  root: '/loyalty-program',
}

export const routes = {
  ROUTES_AUTH,
  ROUTES_CONTEST,
  ROUTES_CONTEST_TABS,
  ROUTES_CONTESTS,
  ROUTES_CONTESTS_TABS,
  ROUTES_DASHBOARD,
  ROUTES_ERROR,
  ROUTES_INFO,
  ROUTES_LOYALTY_PROGRAM,
  ROUTES_OFFERS,
  ROUTES_ONBOARDING,
  ROUTES_PAYMENTS,
  ROUTES_POSTBACKS,
  ROUTES_PROFILE,
  ROUTES_PROMO,
  ROUTES_ROOT,
  ROUTES_SHARED,
  ROUTES_SHARED_VALUES,
  ROUTES_STATISTICS,
  ROUTES_SUB_AFFILIATE,
  ROUTES_TOP,
}
